export const profile = {
  bg: 'https://college-official.oss-cn-hangzhou.aliyuncs.com/materials/project/tour/tour-banner.png',
  bgMD: 'https://college-official.oss-cn-hangzhou.aliyuncs.com/materials/project/tour/tour-banner-MD.png',
  label: '数字文旅',
  subLabel: 'Digital Cultural Tourism',
  content:
    '政策引领、经济支撑、科技助力、消费升级不断推动文化和旅游持续融合，数字文旅成为拼经济的新动能和高质量发展的新引擎。学会将数字文旅作为重点业务之一，开展课题研究、产业共建、地方咨询等服务。',
};
